import { Fragment, useMemo } from 'react'
import { TimelineController } from '../../../../CommonComponents/timeline/Timeline'
import useOrbitAnimationDetails from '../../hooks/useOrbitAnimationDetails'

const ScenarioTimelineController = () => {
    const { orbitAnimationDetails, updateViewerStep, updateViewerState } = useOrbitAnimationDetails()
    const showAnimationDetails = useMemo(() => orbitAnimationDetails.showAnimationDetails, [orbitAnimationDetails.showAnimationDetails])
    const animationSpeed = useMemo(() => orbitAnimationDetails.animationSpeed, [orbitAnimationDetails.animationSpeed])
    const controllerState = useMemo(() => orbitAnimationDetails.controllerState, [orbitAnimationDetails.controllerState])

    const onStepChange = (value: number) => {
        updateViewerStep(value)
    }
    const onControllerChange = (value: 'play' | 'pause') => {
        updateViewerState(value)
    }

    if (!showAnimationDetails) return null
    return (
        <Fragment>
            <TimelineController
                onStepChange={onStepChange}
                onControllerChange={onControllerChange}
                step={animationSpeed}
                controllerState={controllerState}
                showController
            />
        </Fragment>
    )
}

export default ScenarioTimelineController